import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export interface OnboardingAccountConfirmationSubmittedProps extends EventProps {
    accountId: string
}

/**
 * @event onboarding_account_confirmation_submitted
 * @description Emitted when account confirmation is successfully submitted during onboarding.
 */
export const OnboardingAccountConfirmationSubmittedAnalytics =
    createAnalyticsStatic<OnboardingAccountConfirmationSubmittedProps>(
        ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_ACCOUNT_CONFIRMATION_SUBMITTED,
    )

export default OnboardingAccountConfirmationSubmittedAnalytics
